import React from 'react';
import { FlameIcon } from 'lucide-react';
const SPOTS_LEFT = 7;
const FILLED = 93;
export function ScarcityBar() {
  return <div className="rounded-2xl bg-red-50 p-4 ring-1 ring-red-200" data-id="element-48" data-mp="2yv1bzc9rzm6z">
      <p className="flex items-center justify-center gap-1.5 text-center text-[15px] font-extrabold text-red-700" data-id="element-49" data-mp="2l5fuy7fjdh1l">
        <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-50" data-mp="2q2zd3ifcudyt" />
        Only {SPOTS_LEFT} spots left at the promotional price!
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-red-100" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-51" data-mp="2b8uorirs5zw6">
        <div className="bar-stripes flex h-full items-center justify-end rounded-full bg-red-600 pr-2" style={{
        width: `${FILLED}%`
      }} data-id="element-52" data-mp="2766fxb32gsz7">
          <span className="text-[11px] font-bold text-white" data-id="element-53" data-mp="cm78jqfabbw">{FILLED}% claimed</span>
        </div>
      </div>
      <p className="mt-2 text-center text-xs font-medium text-red-700/80" data-id="element-54" data-mp="5bfnul10aiga">
        When the spots run out, the price returns to its regular value.
      </p>
    </div>;
}